/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  HStack,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Tooltip,
  Checkbox,
  Icon,
  Text,
  Button
} from '@chakra-ui/react';
import {
  Heading,
  TextInput,
  useCQMediaQuery,
  usePaginationSessionStorage,
  useTabStorage,
  useBoolean
} from '@laxmimanogna/code-quick-components';
import React, { use, useContext, useEffect, useMemo, useState } from 'react';
import CQContainer from '../../components/layout/CQContainer';
import { FONT_FAMILY } from '../../constants/Theme';
import MyAuditProvider, {
  MyAuditContext,
} from '../../providers/MyAuditProvider';
import RecentAudits from './components/RecentAudits';
import { withMultiProviders, withProvider } from '../../hoc/withProvider';
import AppColors from '../../constants/AppColors';
import { SearchIcon, InfoOutlineIcon, CloseIcon } from '@chakra-ui/icons';
import { UrgentIcon } from '../../constants/IconData';
import Select from 'react-select';
import { CustomTab } from '../../components/CustomTab';
import NewAuditTable from './components/tables/NewAuditTable';
import AuditSheetProvider, { AuditSheetContext } from '../../providers/AuditSheetProvider';
import { ChartFilterInfo, FILTER_OPTIONS, FILTER_OPTIONS_TO_CHART_STATUS_MAP } from '../../constants/constants';
import { DASHBOARD_PAGE_NAME, DASHBOARD_TABLE_NAME } from './constants';
import { AuthContext } from '../../providers/AuthProvider';
import { CQUserType } from '../../utils/cqUserTypeUtils';

const DropdownComponent = ({
  options,
  setSelected,
  selected,
  placeholder = "Select Options",
  isDisabled=false,
  disabledText = "Dropdown disabled",
  isLoading=false,
  isClearable=true,
  isSearchable=true
}) => {
  const handleChange = (option) => {
    setSelected(option);
  }

  return (
    <div
    style={{
      flex:1,
    }}>
      <Select 
      options={options}
      onChange={handleChange}
      isClearable={isClearable}
      placeholder={placeholder}
      isDisabled={isDisabled}
      value={selected}
      isLoading={isLoading}
      isSearchable={isSearchable}
      />
    
    </div> 
  )
}

const DashboardContainerV2 = props => {
  // states
  const {
    getPaginationSession,
    setPaginationSession
  } = usePaginationSessionStorage();
  const tabStorage = useTabStorage();
  const [selectedTab, setSelectedTab] = useState(0);
  const auditSheetContext = useContext(AuditSheetContext)
  const DEFAULT_FILTER_NAME = useMemo(() => "In QA", []);
  const DEFAULT_FILTER_POS = useMemo(() => FILTER_OPTIONS.indexOf(DEFAULT_FILTER_NAME), [DEFAULT_FILTER_NAME])
  const [resetFilterTrigger, rftState] = useBoolean(null);

  // other hooks
  const marginHorizontal = useCQMediaQuery({
    lg: '12%',
    md: '6%',
    sm: '2%',
  });

  // context
  const myAuditContext = useContext(MyAuditContext);
  const authContext = useContext(AuthContext)
  const {
    getRecentAudits,
    handleApplyFilter,
    filterParams,
    getAllCharts,
    isAllChartsLoading,
    myAuditsCheckbox,
    macState
  } = myAuditContext;

  const onSearchAction = () => {
    handleApplyFilter({
      ...filterParams,
      triggerSearch: !filterParams.triggerSearch,
    });
  };

  const onFilterChange = e => {
    handleApplyFilter({
      ...filterParams,
      searchText: e.target.value
    })
  };

  const auditorPortalTabs = [
    {
      title: 'Charts',
      header: 'Charts',
      component: NewAuditTable,
    },
  ];

  // life-cycle hooks
  useEffect(() => {
    getRecentAudits();
  }, []);

  const dropdownOptions = useMemo(
    () => FILTER_OPTIONS.map(val => ({ value: val, label: val })),
    [FILTER_OPTIONS]
  );

  const [selectedFilter, setSelectedFilter] = useState(() => ({
    value: FILTER_OPTIONS[tabStorage.getTab() ?? DEFAULT_FILTER_POS],
    label: FILTER_OPTIONS[tabStorage.getTab() ?? DEFAULT_FILTER_POS]
  }));

  useEffect(() => {
    if (!selectedFilter.value) {
      return;
    }
    tabStorage.setTab(FILTER_OPTIONS.indexOf(selectedFilter.value))
  }, [selectedFilter]);

  const onOpenNotes = (obj, batchId, tabType = undefined) => {
    if (obj && Object.keys(obj).length) {
      if (obj.all) {
        delete auditSheetContext.commentFilters.sheet_name
        auditSheetContext.setCommentFilters({
          ...auditSheetContext.commentFilters,
          page: 1,
          tabType: tabType
        })
      } else if (obj.current) {
        auditSheetContext.setCommentFilters({
          ...auditSheetContext.commentFilters,
          sheet_name: "Sheet1",
          page: 1,
          tabType: tabType
        })
      }
    } else {
      auditSheetContext.setCommentFilters({
        ...auditSheetContext.commentFilters,
        batchId,
        sheet_name: "Sheet1",
        reverse: true,
        page: 1,
        tabType: tabType
      })
    }
  }


  return (
    <Box>
      <Box py={5} height={250} bg={'white'} px={marginHorizontal}>
        <Heading
          fontSize={'24px'}
          fontFamily={FONT_FAMILY.baiJamurjee}
          fontWeight="bold"
        >
          Recent Audits
        </Heading>
        <RecentAudits />
      </Box>
      <CQContainer>
        <Heading my={5} fontSize={'xl'}>
          {auditorPortalTabs[selectedTab].header}
        </Heading>
        <Box
          shadow={'md'}
          bg="white"
          p={4}
          w="100%"
          style={{ borderRadius: '12px' }}
        >
          <Tabs
            fontFamily={FONT_FAMILY.baiJamurjee}
            onChange={setSelectedTab}
            index={selectedTab}
          >
            <TabList>
              <HStack w={'100%'} justifyContent={'space-between'}>
                {/* filtersss */}
                  <Box width={"35%"}>
                    <HStack>
                      <Tooltip
                        p={3}
                        bg="whiteAlpha.900"
                        color="black"
                        borderRadius="md"
                        border="1px solid #43dde0"
                        closeDelay={100}
                        label={
                          <Box>
                            {ChartFilterInfo.map((item, index) => (
                              <Box key={item.name} mb={index !== ChartFilterInfo.length - 1 ? 2 : 0}>
                                <Box fontWeight="600" fontSize="sm">
                                  {item.name}
                                </Box>

                                <Box fontSize="s" color="gray.600">
                                  {item.definition}
                                </Box>
                              </Box>
                            ))}
                          </Box>
                        }
                        placement="top-end"
                      >
                        <Box>
                          <Icon
                            as={InfoOutlineIcon}
                            w={4}
                            h={4}
                            cursor="pointer"
                            color={AppColors.primary}
                            _hover={{
                              color: AppColors.secondary,
                              transition: "color 0.3s ease-in-out",
                            }}
                          />
                        </Box>
                      </Tooltip>
                      <Box width={"60%"}>
                        <DropdownComponent
                        options={dropdownOptions}
                        selected={selectedFilter}
                        setSelected={option => {
                          setSelectedFilter(option);
                          handleApplyFilter({
                            ...filterParams, 
                            triggerSearch: !filterParams.triggerSearch,
                            chartStatusType: option.value
                          });
                        }}
                        placeholder=''
                        isClearable={false}
                        isSearchable={false}
                        isDisabled={isAllChartsLoading}
                        isLoading={isAllChartsLoading}
                        />
                      </Box>

                      {authContext.currentUser.role === CQUserType.ADMIN && (
                        <Box width={"40%"}>
                          <Checkbox
                          isChecked={myAuditsCheckbox}
                          onChange={e => {
                            getAllCharts.loadPageByFilterParams(DASHBOARD_PAGE_NAME, DASHBOARD_TABLE_NAME, {'my_qas': !myAuditsCheckbox})
                            macState.toggle();
                          }}
                          >
                          Assigned to me
                          </Checkbox>
                        </Box>
                      )}
                    </HStack>
                  </Box>
                <Box>
                  <HStack>
                    <Button
                    mr={1}
                    mb={2}
                    isDisabled={isAllChartsLoading}
                    cursor={isAllChartsLoading ? "not-allowed" : "pointer"}
                    color={AppColors.secondary}
                    fontSize="15px"
                    display="flex"
                    alignItems="center"
                    _hover={
                      !isAllChartsLoading
                        ? {
                            color: "red.500",
                            textDecoration: "underline",
                          }
                        : undefined
                    }
                    onClick={() => {
                      macState.on();
                      setSelectedFilter(dropdownOptions[DEFAULT_FILTER_POS]);
                      setPaginationSession(
                        DASHBOARD_PAGE_NAME, 
                        DASHBOARD_TABLE_NAME, 
                        {
                          ...getPaginationSession(DASHBOARD_PAGE_NAME, DASHBOARD_TABLE_NAME),
                          page: 1,
                          size: 10
                        }
                      )
                      handleApplyFilter({
                        searchText: "",
                        triggerSearch: !filterParams.triggerSearch,
                        ordering: "",
                        chartStatusType: DEFAULT_FILTER_NAME,
                      });
                      rftState.toggle();
                    }}
                  >
                    Clear Filters
                    
                  </Button>
                    <TextInput
                      borderRadius={'md'}
                      value={filterParams?.searchText}
                      onChange={e => onFilterChange(e)}
                      onKeyDown={e => {
                        if (e.keyCode === 13) {
                          onSearchAction();
                        }
                      }}
                      mb="2"
                      rightIconProps={{ zIndex: 0 }}
                      placeholder="Search"
                      rightIcon={<SearchIcon onClick={onSearchAction} />}
                      isDisabled={isAllChartsLoading}
                    />
                  </HStack>
                </Box>
              </HStack>
            </TabList>

            <TabPanels>
              {auditorPortalTabs.map((apt, i) => {
                return (
                  <TabPanel p={0} key={`assigned-audit-panel-${i}`}>
                    <apt.component 
                    key={`my-charts-panel-${i}`} 
                    onOpenNotes={onOpenNotes} 
                    PAGE_NAME={DASHBOARD_PAGE_NAME} 
                    TABLE_NAME={DASHBOARD_TABLE_NAME}
                    filterResetTrigger={resetFilterTrigger}
                    />
                  </TabPanel>
                );
              })}
            </TabPanels>
          </Tabs>
        </Box>
      </CQContainer>
    </Box>
  );
};

export default withMultiProviders(
  [MyAuditProvider, AuditSheetProvider],
  DashboardContainerV2
);
